!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if ("function" == typeof define && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : t(e.react, e.classnames, e["@material/react-ripple/dist/index.js"]);
    for (var i in n) ("object" == typeof exports ? exports : e)[i] = n[i];
  }
}("undefined" != typeof self ? self : this, function (e, t, n) {
  return function (e) {
    var t = {};
    function n(i) {
      if (t[i]) return t[i].exports;
      var o = t[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return e[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(i, o, function (t) {
        return e[t];
      }.bind(null, o));
      return i;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 55);
  }({
    0: function _(t, n) {
      t.exports = e;
    },
    1: function _(e, n) {
      e.exports = t;
    },
    167: function _(e, t, n) {
      "use strict";

      n.r(t);
      var i = n(21),
        o = n(26),
        r = {
          CHECKMARK_SELECTOR: ".mdc-chip__checkmark",
          ENTRY_ANIMATION_NAME: "mdc-chip-entry",
          INTERACTION_EVENT: "MDCChip:interaction",
          LEADING_ICON_SELECTOR: ".mdc-chip__icon--leading",
          REMOVAL_EVENT: "MDCChip:removal",
          SELECTION_EVENT: "MDCChip:selection",
          TRAILING_ICON_INTERACTION_EVENT: "MDCChip:trailingIconInteraction",
          TRAILING_ICON_SELECTOR: ".mdc-chip__icon--trailing"
        },
        a = {
          CHECKMARK: "mdc-chip__checkmark",
          CHIP_EXIT: "mdc-chip--exit",
          HIDDEN_LEADING_ICON: "mdc-chip__icon--leading-hidden",
          LEADING_ICON: "mdc-chip__icon--leading",
          SELECTED: "mdc-chip--selected",
          TRAILING_ICON: "mdc-chip__icon--trailing"
        };
      n.d(t, "MDCChipFoundation", function () {
        return s;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var c = {
          bottom: 0,
          height: 0,
          left: 0,
          right: 0,
          top: 0,
          width: 0
        },
        s = function (e) {
          function t(n) {
            var o = e.call(this, i.a({}, t.defaultAdapter, n)) || this;
            return o.shouldRemoveOnTrailingIconClick_ = !0, o;
          }
          return i.b(t, e), Object.defineProperty(t, "strings", {
            get: function get() {
              return r;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "cssClasses", {
            get: function get() {
              return a;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "defaultAdapter", {
            get: function get() {
              return {
                addClass: function addClass() {},
                addClassToLeadingIcon: function addClassToLeadingIcon() {},
                eventTargetHasClass: function eventTargetHasClass() {
                  return !1;
                },
                getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                  return c;
                },
                getComputedStyleValue: function getComputedStyleValue() {
                  return "";
                },
                getRootBoundingClientRect: function getRootBoundingClientRect() {
                  return c;
                },
                hasClass: function hasClass() {
                  return !1;
                },
                hasLeadingIcon: function hasLeadingIcon() {
                  return !1;
                },
                notifyInteraction: function notifyInteraction() {},
                notifyRemoval: function notifyRemoval() {},
                notifySelection: function notifySelection() {},
                notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {},
                removeClass: function removeClass() {},
                removeClassFromLeadingIcon: function removeClassFromLeadingIcon() {},
                setStyleProperty: function setStyleProperty() {}
              };
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.isSelected = function () {
            return this.adapter_.hasClass(a.SELECTED);
          }, t.prototype.setSelected = function (e) {
            e ? this.adapter_.addClass(a.SELECTED) : this.adapter_.removeClass(a.SELECTED), this.adapter_.notifySelection(e);
          }, t.prototype.getShouldRemoveOnTrailingIconClick = function () {
            return this.shouldRemoveOnTrailingIconClick_;
          }, t.prototype.setShouldRemoveOnTrailingIconClick = function (e) {
            this.shouldRemoveOnTrailingIconClick_ = e;
          }, t.prototype.getDimensions = function () {
            var e = this,
              t = function t() {
                return e.adapter_.getRootBoundingClientRect();
              };
            if (!this.adapter_.hasLeadingIcon()) {
              var n = e.adapter_.getCheckmarkBoundingClientRect();
              if (n) {
                var i = t();
                return {
                  bottom: i.bottom,
                  height: i.height,
                  left: i.left,
                  right: i.right,
                  top: i.top,
                  width: i.width + n.height
                };
              }
            }
            return t();
          }, t.prototype.beginExit = function () {
            this.adapter_.addClass(a.CHIP_EXIT);
          }, t.prototype.handleInteraction = function (e) {
            var t = "Enter" === e.key || 13 === e.keyCode;
            ("click" === e.type || t) && this.adapter_.notifyInteraction();
          }, t.prototype.handleTransitionEnd = function (e) {
            var t = this;
            if (this.adapter_.eventTargetHasClass(e.target, a.CHIP_EXIT)) {
              if ("width" === e.propertyName) this.adapter_.notifyRemoval();else if ("opacity" === e.propertyName) {
                var n = this.adapter_.getComputedStyleValue("width");
                requestAnimationFrame(function () {
                  t.adapter_.setStyleProperty("width", n), t.adapter_.setStyleProperty("padding", "0"), t.adapter_.setStyleProperty("margin", "0"), requestAnimationFrame(function () {
                    t.adapter_.setStyleProperty("width", "0");
                  });
                });
              }
            } else "opacity" === e.propertyName && (this.adapter_.eventTargetHasClass(e.target, a.LEADING_ICON) && this.adapter_.hasClass(a.SELECTED) ? this.adapter_.addClassToLeadingIcon(a.HIDDEN_LEADING_ICON) : this.adapter_.eventTargetHasClass(e.target, a.CHECKMARK) && !this.adapter_.hasClass(a.SELECTED) && this.adapter_.removeClassFromLeadingIcon(a.HIDDEN_LEADING_ICON));
          }, t.prototype.handleTrailingIconInteraction = function (e) {
            var t = "Enter" === e.key || 13 === e.keyCode;
            e.stopPropagation(), ("click" === e.type || t) && (this.adapter_.notifyTrailingIconInteraction(), this.shouldRemoveOnTrailingIconClick_ && this.beginExit());
          }, t;
        }(o.a);
      t.default = s;
    },
    173: function _(e, t, n) {
      "use strict";

      n.r(t);
      var i = n(21),
        o = n(26),
        r = {
          CHIP_SELECTOR: ".mdc-chip"
        },
        a = {
          CHOICE: "mdc-chip-set--choice",
          FILTER: "mdc-chip-set--filter"
        };
      n.d(t, "MDCChipSetFoundation", function () {
        return c;
      });
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var c = function (e) {
        function t(n) {
          var o = e.call(this, i.a({}, t.defaultAdapter, n)) || this;
          return o.selectedChipIds_ = [], o;
        }
        return i.b(t, e), Object.defineProperty(t, "strings", {
          get: function get() {
            return r;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "cssClasses", {
          get: function get() {
            return a;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "defaultAdapter", {
          get: function get() {
            return {
              hasClass: function hasClass() {
                return !1;
              },
              removeChip: function removeChip() {},
              setSelected: function setSelected() {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.getSelectedChipIds = function () {
          return this.selectedChipIds_.slice();
        }, t.prototype.select = function (e) {
          if (!(this.selectedChipIds_.indexOf(e) >= 0)) {
            if (this.adapter_.hasClass(a.CHOICE) && this.selectedChipIds_.length > 0) {
              var t = this.selectedChipIds_[0];
              this.selectedChipIds_.length = 0, this.adapter_.setSelected(t, !1);
            }
            this.selectedChipIds_.push(e), this.adapter_.setSelected(e, !0);
          }
        }, t.prototype.handleChipInteraction = function (e) {
          (this.adapter_.hasClass(a.CHOICE) || this.adapter_.hasClass(a.FILTER)) && this.toggleSelect_(e);
        }, t.prototype.handleChipSelection = function (e, t) {
          var n = this.selectedChipIds_.indexOf(e) >= 0;
          t && !n ? this.select(e) : !t && n && this.deselect_(e);
        }, t.prototype.handleChipRemoval = function (e) {
          this.deselect_(e), this.adapter_.removeChip(e);
        }, t.prototype.deselect_ = function (e) {
          var t = this.selectedChipIds_.indexOf(e);
          t >= 0 && (this.selectedChipIds_.splice(t, 1), this.adapter_.setSelected(e, !1));
        }, t.prototype.toggleSelect_ = function (e) {
          this.selectedChipIds_.indexOf(e) >= 0 ? this.deselect_(e) : this.select(e);
        }, t;
      }(o.a);
      t.default = c;
    },
    21: function _(e, t, n) {
      "use strict";

      n.d(t, "b", function () {
        return o;
      }), n.d(t, "a", function () {
        return _r;
      });
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var _i = function i(e, t) {
        return (_i = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      };
      function o(e, t) {
        function n() {
          this.constructor = e;
        }
        _i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }
      var _r = function r() {
        return (_r = Object.assign || function (e) {
          for (var t, n = 1, i = arguments.length; n < i; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }).apply(this, arguments);
      };
    },
    26: function _(e, t, n) {
      "use strict";

      n.d(t, "a", function () {
        return i;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var i = function () {
        function e(e) {
          void 0 === e && (e = {}), this.adapter_ = e;
        }
        return Object.defineProperty(e, "cssClasses", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "strings", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function get() {
            return {};
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {}, e.prototype.destroy = function () {}, e;
      }();
    },
    40: function _(e, t, n) {
      "use strict";

      var _i2,
        o = this && this.__extends || (_i2 = function i(e, t) {
          return (_i2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(e, t);
        }, function (e, t) {
          function n() {
            this.constructor = e;
          }
          _i2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }),
        r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var a = r(n(0)),
        c = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.width = 0, t.init = function (e) {
              e && (t.width = e.getBoundingClientRect().height);
            }, t;
          }
          return o(t, e), t.prototype.render = function () {
            return a.default.createElement("div", {
              className: "mdc-chip__checkmark",
              ref: this.init
            }, a.default.createElement("svg", {
              className: "mdc-chip__checkmark-svg",
              viewBox: "-2 -3 30 30",
              focusable: "false"
            }, a.default.createElement("path", {
              className: "mdc-chip__checkmark-path",
              fill: "none",
              stroke: "black",
              d: "M1.73,12.91 8.1,19.28 22.79,4.59"
            })));
          }, t;
        }(a.default.Component);
      t.default = c;
    },
    5: function _(e, t) {
      e.exports = n;
    },
    55: function _(e, t, n) {
      "use strict";

      var i = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = i(n(56));
      t.Chip = o.default;
      var r = i(n(40));
      t.ChipCheckmark = r.default;
      var a = i(n(57));
      t.ChipSet = a.default;
    },
    56: function _(e, t, n) {
      "use strict";

      var _i3,
        o = this && this.__extends || (_i3 = function i(e, t) {
          return (_i3 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(e, t);
        }, function (e, t) {
          function n() {
            this.constructor = e;
          }
          _i3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }),
        r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, i = arguments.length; n < i; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (e, t) {
          var n = {};
          for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (i = Object.getOwnPropertySymbols(e); o < i.length; o++) t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]);
          }
          return n;
        },
        c = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var s = c(n(0)),
        l = c(n(1)),
        u = n(5),
        d = n(167),
        p = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.chipElement = null, t.state = {
              classList: new Set(),
              leadingIconClassList: new Set()
            }, t.init = function (e) {
              t.chipElement = e, t.props.initRipple && t.props.initRipple(e);
            }, t.onClick = function (e) {
              t.props.onClick(e), t.foundation.handleInteraction(e.nativeEvent);
            }, t.onKeyDown = function (e) {
              t.props.onKeyDown(e), t.foundation.handleInteraction(e.nativeEvent);
            }, t.handleTrailingIconClick = function (e) {
              return t.foundation.handleTrailingIconInteraction(e.nativeEvent);
            }, t.handleTransitionEnd = function (e) {
              t.props.onTransitionEnd(e), t.foundation.handleTransitionEnd(e.nativeEvent);
            }, t.renderLeadingIcon = function (e) {
              var n = t.state.leadingIconClassList,
                i = e.props,
                o = i.className,
                c = a(i, ["className"]),
                u = r({
                  className: l.default(o, Array.from(n), "mdc-chip__icon", "mdc-chip__icon--leading")
                }, c);
              return s.default.cloneElement(e, u);
            }, t.renderTrailingIcon = function (e) {
              var n = e.props,
                i = n.className,
                o = a(n, ["className"]),
                c = r({
                  className: l.default(i, "mdc-chip__icon", "mdc-chip__icon--trailing"),
                  onClick: t.handleTrailingIconClick,
                  onKeyDown: t.handleTrailingIconClick,
                  tabIndex: 0,
                  role: "button"
                }, o);
              return s.default.cloneElement(e, c);
            }, t;
          }
          return o(t, e), t.prototype.componentDidMount = function () {
            var e = this.props,
              t = e.selected,
              n = e.shouldRemoveOnTrailingIconClick;
            this.foundation = new d.MDCChipFoundation(this.adapter), this.foundation.init(), this.foundation.setSelected(t), n !== this.foundation.getShouldRemoveOnTrailingIconClick() && this.foundation.setShouldRemoveOnTrailingIconClick(n);
          }, t.prototype.componentDidUpdate = function (e) {
            var t = this.props,
              n = t.selected,
              i = t.shouldRemoveOnTrailingIconClick;
            n !== e.selected && this.foundation.setSelected(n), i !== e.shouldRemoveOnTrailingIconClick && this.foundation.setShouldRemoveOnTrailingIconClick(i);
          }, t.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          }, Object.defineProperty(t.prototype, "classes", {
            get: function get() {
              var e = this.state.classList,
                t = this.props.className;
              return l.default("mdc-chip", Array.from(e), t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "adapter", {
            get: function get() {
              var e = this;
              return {
                addClass: function addClass(t) {
                  var n = new Set(e.state.classList);
                  n.add(t), e.setState({
                    classList: n
                  });
                },
                removeClass: function removeClass(t) {
                  var n = new Set(e.state.classList);
                  n.delete(t), e.setState({
                    classList: n
                  });
                },
                hasClass: function hasClass(t) {
                  return e.classes.split(" ").includes(t);
                },
                hasLeadingIcon: function hasLeadingIcon() {
                  return Boolean(e.props.leadingIcon);
                },
                eventTargetHasClass: function eventTargetHasClass(e, t) {
                  return e.classList.contains(t);
                },
                getComputedStyleValue: function getComputedStyleValue(t) {
                  return e.chipElement ? window.getComputedStyle(e.chipElement).getPropertyValue(t) : "";
                },
                getRootBoundingClientRect: function getRootBoundingClientRect() {
                  if (!e.chipElement) {
                    return {
                      bottom: 0,
                      height: 0,
                      left: 0,
                      right: 0,
                      top: 0,
                      width: 0,
                      x: 0,
                      y: 0
                    };
                  }
                  return e.chipElement.getBoundingClientRect();
                },
                getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                  var t = e.props.chipCheckmark;
                  if (!(t && t.props && t.props.getBoundingClientRect)) {
                    return {
                      bottom: 0,
                      height: 0,
                      left: 0,
                      right: 0,
                      top: 0,
                      width: 0,
                      x: 0,
                      y: 0
                    };
                  }
                  return t.props.getBoundingClientRect();
                },
                setStyleProperty: function setStyleProperty(t, n) {
                  e.chipElement && e.chipElement.style.setProperty(t, n);
                },
                notifyRemoval: function notifyRemoval() {
                  return e.props.handleRemove(e.props.id);
                },
                notifyInteraction: function notifyInteraction() {
                  return e.props.handleInteraction(e.props.id);
                },
                notifySelection: function notifySelection(t) {
                  return e.props.handleSelect(e.props.id, t);
                },
                notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                  return e.props.handleTrailingIconInteraction(e.props.id);
                },
                addClassToLeadingIcon: function addClassToLeadingIcon(t) {
                  var n = new Set(e.state.leadingIconClassList);
                  n.add(t), e.setState({
                    leadingIconClassList: n
                  });
                },
                removeClassFromLeadingIcon: function removeClassFromLeadingIcon(t) {
                  var n = new Set(e.state.leadingIconClassList);
                  n.delete(t), e.setState({
                    leadingIconClassList: n
                  });
                }
              };
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.render = function () {
            var e = this.props,
              t = (e.id, e.className, e.selected, e.handleSelect, e.handleInteraction, e.handleRemove, e.handleTrailingIconInteraction, e.onClick, e.onKeyDown, e.onTransitionEnd, e.computeBoundingRect, e.initRipple, e.unbounded, e.shouldRemoveOnTrailingIconClick, e.chipCheckmark),
              n = e.leadingIcon,
              i = e.trailingIcon,
              o = e.label,
              c = a(e, ["id", "className", "selected", "handleSelect", "handleInteraction", "handleRemove", "handleTrailingIconInteraction", "onClick", "onKeyDown", "onTransitionEnd", "computeBoundingRect", "initRipple", "unbounded", "shouldRemoveOnTrailingIconClick", "chipCheckmark", "leadingIcon", "trailingIcon", "label"]);
            return s.default.createElement("div", r({
              tabIndex: 0,
              className: this.classes,
              onClick: this.onClick,
              onKeyDown: this.onKeyDown,
              onTransitionEnd: this.handleTransitionEnd,
              ref: this.init
            }, c), n && this.renderLeadingIcon(n), t, s.default.createElement("div", {
              className: "mdc-chip__text"
            }, o), i && this.renderTrailingIcon(i));
          }, t.defaultProps = {
            id: "",
            label: "",
            className: "",
            selected: !1,
            onClick: function onClick() {},
            onKeyDown: function onKeyDown() {},
            onTransitionEnd: function onTransitionEnd() {},
            initRipple: function initRipple() {},
            handleSelect: function handleSelect() {},
            handleRemove: function handleRemove() {},
            handleInteraction: function handleInteraction() {},
            handleTrailingIconInteraction: function handleTrailingIconInteraction() {},
            shouldRemoveOnTrailingIconClick: !0
          }, t;
        }(s.default.Component);
      t.Chip = p, t.default = u.withRipple(p);
    },
    57: function _(e, t, n) {
      "use strict";

      var _i4,
        o = this && this.__extends || (_i4 = function i(e, t) {
          return (_i4 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          })(e, t);
        }, function (e, t) {
          function n() {
            this.constructor = e;
          }
          _i4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }),
        r = this && this.__rest || function (e, t) {
          var n = {};
          for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (i = Object.getOwnPropertySymbols(e); o < i.length; o++) t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]);
          }
          return n;
        },
        a = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var c = a(n(0)),
        s = n(58),
        l = a(n(1)),
        u = n(173),
        d = a(n(40)),
        p = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.checkmarkWidth = 0, n.handleInteraction = function (e) {
              n.state.foundation.handleChipInteraction(e);
            }, n.handleSelect = function (e, t) {
              n.state.foundation.handleChipSelection(e, t);
            }, n.handleRemove = function (e) {
              n.state.foundation.handleChipRemoval(e);
            }, n.removeChip = function (e) {
              var t = n.props,
                i = t.updateChips,
                o = t.children;
              if (o) {
                for (var r = c.default.Children.toArray(o).filter(s.isElement).slice(), a = 0; a < r.length; a++) {
                  if (r[a].props.id === e) {
                    r.splice(a, 1);
                    break;
                  }
                }
                i(r.length ? r.map(function (e) {
                  return e.props;
                }) : []);
              }
            }, n.setCheckmarkWidth = function (e) {
              !n.checkmarkWidth && e && (n.checkmarkWidth = e.width);
            }, n.computeBoundingRect = function (e) {
              var t = e.getBoundingClientRect();
              return {
                height: t.height,
                width: t.width + n.checkmarkWidth
              };
            }, n.renderChip = function (e) {
              if (e && s.isElement(e)) {
                var t = n.props,
                  i = t.choice,
                  o = t.filter,
                  a = t.input;
                if ((i || o || a) && !e.props.id) throw new Error("Chip variant missing required property: id.");
                var l = n.state.selectedChipIds.indexOf(e.props.id) > -1,
                  u = e.props,
                  p = u.handleInteraction,
                  f = u.handleSelect,
                  h = u.handleRemove,
                  m = r(u, ["handleInteraction", "handleSelect", "handleRemove"]),
                  y = Object.assign.apply(Object, [{}].concat(m, [{
                    selected: l,
                    handleSelect: function handleSelect(e, t) {
                      f(e, t), n.handleSelect(e, t);
                    },
                    handleInteraction: function handleInteraction(e) {
                      p(e), n.handleInteraction(e);
                    },
                    handleRemove: function handleRemove(e) {
                      h(e), n.handleRemove(e);
                    },
                    chipCheckmark: o ? c.default.createElement(d.default, {
                      ref: n.setCheckmarkWidth
                    }) : null,
                    computeBoundingRect: o ? n.computeBoundingRect : null
                  }]));
                return c.default.cloneElement(e, y);
              }
            }, n.state = {
              selectedChipIds: t.selectedChipIds,
              foundation: null,
              hasInitialized: !1
            }, n;
          }
          return o(t, e), t.prototype.componentDidMount = function () {
            var e = new u.MDCChipSetFoundation(this.adapter);
            this.setState({
              foundation: e
            }), e.init();
          }, t.prototype.componentDidUpdate = function (e, t) {
            var n = this.props.selectedChipIds;
            this.state.foundation !== t.foundation && this.initChipSelection(), n !== e.selectedChipIds && this.setState({
              selectedChipIds: n
            });
          }, t.prototype.componentWillUnmount = function () {
            this.state.foundation && this.state.foundation.destroy();
          }, Object.defineProperty(t.prototype, "classes", {
            get: function get() {
              var e = this.props,
                t = e.className,
                n = e.filter,
                i = e.choice,
                o = e.input;
              return l.default("mdc-chip-set", t, {
                "mdc-chip-set--filter": n,
                "mdc-chip-set--choice": i,
                "mdc-chip-set--input": o
              });
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "adapter", {
            get: function get() {
              var e = this;
              return {
                hasClass: function hasClass(t) {
                  return e.classes.split(" ").includes(t);
                },
                setSelected: function setSelected() {
                  var t = e.state.foundation.getSelectedChipIds().slice();
                  e.setState({
                    selectedChipIds: t
                  }, function () {
                    e.props.handleSelect(t);
                  });
                },
                removeChip: this.removeChip
              };
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.initChipSelection = function () {
            var e = this;
            c.default.Children.forEach(this.props.children, function (t) {
              if (t && s.isElement(t)) {
                var n = t.props.id;
                e.state.selectedChipIds.indexOf(n) > -1 && e.state.foundation.select(n);
              }
            }), this.setState({
              hasInitialized: !0
            });
          }, t.prototype.render = function () {
            return this.state.hasInitialized ? c.default.createElement("div", {
              className: this.classes
            }, c.default.Children.map(this.props.children, this.renderChip)) : null;
          }, t.defaultProps = {
            className: "",
            selectedChipIds: [],
            handleSelect: function handleSelect() {},
            updateChips: function updateChips() {},
            choice: !1,
            filter: !1,
            input: !1
          }, t;
        }(c.default.Component);
      t.default = p;
    },
    58: function _(e, t, n) {
      "use strict";

      e.exports = n(59);
    },
    59: function _(e, t, n) {
      "use strict";

      /** @license React v16.8.6
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = "function" == typeof Symbol && Symbol.for,
        r = o ? Symbol.for("react.element") : 60103,
        a = o ? Symbol.for("react.portal") : 60106,
        c = o ? Symbol.for("react.fragment") : 60107,
        s = o ? Symbol.for("react.strict_mode") : 60108,
        l = o ? Symbol.for("react.profiler") : 60114,
        u = o ? Symbol.for("react.provider") : 60109,
        d = o ? Symbol.for("react.context") : 60110,
        p = o ? Symbol.for("react.async_mode") : 60111,
        f = o ? Symbol.for("react.concurrent_mode") : 60111,
        h = o ? Symbol.for("react.forward_ref") : 60112,
        m = o ? Symbol.for("react.suspense") : 60113,
        y = o ? Symbol.for("react.memo") : 60115,
        C = o ? Symbol.for("react.lazy") : 60116;
      function _(e) {
        if ("object" === (void 0 === e ? "undefined" : i(e)) && null !== e) {
          var t = e.$$typeof;
          switch (t) {
            case r:
              switch (e = e.type) {
                case p:
                case f:
                case c:
                case l:
                case s:
                case m:
                  return e;
                default:
                  switch (e = e && e.$$typeof) {
                    case d:
                    case h:
                    case u:
                      return e;
                    default:
                      return t;
                  }
              }
            case C:
            case y:
            case a:
              return t;
          }
        }
      }
      function g(e) {
        return _(e) === f;
      }
      t.typeOf = _, t.AsyncMode = p, t.ConcurrentMode = f, t.ContextConsumer = d, t.ContextProvider = u, t.Element = r, t.ForwardRef = h, t.Fragment = c, t.Lazy = C, t.Memo = y, t.Portal = a, t.Profiler = l, t.StrictMode = s, t.Suspense = m, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === c || e === f || e === l || e === s || e === m || "object" === (void 0 === e ? "undefined" : i(e)) && null !== e && (e.$$typeof === C || e.$$typeof === y || e.$$typeof === u || e.$$typeof === d || e.$$typeof === h);
      }, t.isAsyncMode = function (e) {
        return g(e) || _(e) === p;
      }, t.isConcurrentMode = g, t.isContextConsumer = function (e) {
        return _(e) === d;
      }, t.isContextProvider = function (e) {
        return _(e) === u;
      }, t.isElement = function (e) {
        return "object" === (void 0 === e ? "undefined" : i(e)) && null !== e && e.$$typeof === r;
      }, t.isForwardRef = function (e) {
        return _(e) === h;
      }, t.isFragment = function (e) {
        return _(e) === c;
      }, t.isLazy = function (e) {
        return _(e) === C;
      }, t.isMemo = function (e) {
        return _(e) === y;
      }, t.isPortal = function (e) {
        return _(e) === a;
      }, t.isProfiler = function (e) {
        return _(e) === l;
      }, t.isStrictMode = function (e) {
        return _(e) === s;
      }, t.isSuspense = function (e) {
        return _(e) === m;
      };
    }
  });
});